import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { enrollmentAPI, certificateAPI } from '../../services/api';
import { LoadingSpinner, EmptyState } from '../../components/UI';

const TrainerStudents = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await enrollmentAPI.trainerStudents();
      setStudents(data);
    } catch (e) { toast.error('Failed to load'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const issueCert = async (enrollmentId) => {
    if (!window.confirm('Issue a certificate for this student?')) return;
    try {
      await certificateAPI.issue(enrollmentId);
      toast.success('Certificate issued!');
      fetchData();
    } catch (e) {
      toast.error(e.response?.data?.message || 'Failed to issue');
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1 style={{ color: 'var(--green)' }}>Enrolled Students</h1>
          <p className="subtitle">{students.length} students across your courses</p>
        </div>
      </div>

      {students.length === 0 ? (
        <EmptyState icon="👨‍🎓" title="No students yet" message="Students will appear here once admin approves enrollments" />
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Course</th>
                <th>Progress</th>
                <th>Quiz Score</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {students.map((s) => (
                <tr key={s._id}>
                  <td>
                    <strong>{s.user?.name}</strong>
                    <div className="text-muted" style={{ fontSize: '0.8rem' }}>{s.user?.email}</div>
                  </td>
                  <td>{s.course?.title}</td>
                  <td>
                    <div style={{ minWidth: 120 }}>
                      <div className="progress"><div className="progress-bar" style={{ width: `${s.progress}%` }}></div></div>
                      <small className="text-muted">{s.progress}%</small>
                    </div>
                  </td>
                  <td>{s.quizScore !== null ? `${s.quizScore}% ${s.quizPassed ? '✓' : '✗'}` : '—'}</td>
                  <td><span className={`badge badge-${s.status}`}>{s.status}</span></td>
                  <td>
                    {s.progress === 100 && s.status !== 'completed' && (
                      <button className="btn btn-success btn-sm" onClick={() => issueCert(s._id)}>
                        🏆 Issue Certificate
                      </button>
                    )}
                    {s.status === 'completed' && <span className="text-muted">✅ Done</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TrainerStudents;
